module.exports = __webpack_public_path__ + "static/media/Home.9f638663.svg";